var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGrayPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A2A6A9",
  fillRule: "nonzero",
  d: "M11 5v4h4v2h-4v4H9v-4.001L5 11V9l4-.001V5h2z"
})));
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSIjQTJBNkE5IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMSA1djRoNHYyaC00djRIOXYtNC4wMDFMNSAxMVY5bDQtLjAwMVY1aDJ6Ii8+DQo8L3N2Zz4NCg==";
export { SvgGrayPlus as ReactComponent };